import { render, staticRenderFns } from "./onSubFormRowAdd-editor.vue?vue&type=template&id=4e7e840d&scoped=true&"
import script from "./onSubFormRowAdd-editor.vue?vue&type=script&lang=js&"
export * from "./onSubFormRowAdd-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7e840d",
  null
  
)

export default component.exports